import {
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
  MessageBarActions,
  Button,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { useNotifications } from './NotificationContext';

/**
 * Renders the active notification queue as a stack of Fluent MessageBars
 * pinned to the bottom-right of the viewport (.notification-area in App.css).
 * Mount once near the root of the shell.
 */
export function NotificationArea() {
  const { notifications, dismiss } = useNotifications();

  if (notifications.length === 0) return null;

  return (
    <div className="notification-area" role="status" aria-live="polite">
      {notifications.map(n => (
        <MessageBar key={n.id} intent={n.intent}>
          <MessageBarBody>
            {n.title && <MessageBarTitle>{n.title}</MessageBarTitle>}
            {n.message}
          </MessageBarBody>
          <MessageBarActions
            containerAction={
              <Button
                appearance="transparent"
                icon={<DismissRegular />}
                onClick={() => dismiss(n.id)}
                aria-label="Dismiss notification"
              />
            }
          />
        </MessageBar>
      ))}
    </div>
  );
}
